<script setup>
const auth = useAuth()
// 인증데이터가 초가화 될 때 까지 대기. 리포트 페이지에 바로 접근하면 초기화가 안된 상태라 에러 발생(대시보드가 일시적으로 렌더링 됐다가 이동)
//! local에선 requiredAuthCode의 경우 accountStatus 값이 할당 안되는데, 배포하면 초기 값인 retainingAccountInfo로 할당됨
const requireRetainedAccountInfo =
  auth.factor === 'requiredAccount' &&
  auth.accountStatus === 'retainingAccountInfo'
</script>

<template>
  <div>
    <NuxtLayout>
      <NuxtPage v-if="!requireRetainedAccountInfo" />
      <!--! 인증데이터가 초가화 될 때 까지 대기. 리포트 페이지에 바로 접근하면 accessKey 초기화가 안되서 에러 발생. -->
    </NuxtLayout>
    <DefaultToast />
  </div>
</template>
